// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
export const namedOperations = {
  Query: {
    getAddOnsByOutfitterAndOfferPeriod: 'getAddOnsByOutfitterAndOfferPeriod',
    getDefaultImage: 'getDefaultImage',
    getAddOnsByListingAndOfferPeriod: 'getAddOnsByListingAndOfferPeriod',
    getAddOnsForBooking: 'getAddOnsForBooking',
    adminAiContext: 'adminAiContext',
    aiOnboarding: 'aiOnboarding',
    aiOnboardingById: 'aiOnboardingById',
    getRichTextAiSuggestion: 'getRichTextAiSuggestion',
    getAllAmenities: 'getAllAmenities',
    appPrompts: 'appPrompts',
    auctionRequest: 'auctionRequest',
    auctionRequests: 'auctionRequests',
    auction: 'auction',
    auctions: 'auctions',
    availableDatesForEditBooking: 'availableDatesForEditBooking',
    availability: 'availability',
    availableDatesForCalendarEventResources: 'availableDatesForCalendarEventResources',
    listingAvailabilityForDashboardCheckout: 'listingAvailabilityForDashboardCheckout',
    dashboardCheckoutMaxAvailableSlots: 'dashboardCheckoutMaxAvailableSlots',
    resourcesWithSupportForAvailability: 'resourcesWithSupportForAvailability',
    resourceWithSupportForAvailability: 'resourceWithSupportForAvailability',
    awardedItem: 'awardedItem',
    awardedItems: 'awardedItems',
    badges: 'badges',
    outfittersByBadge: 'outfittersByBadge',
    bookingInvite: 'bookingInvite',
    getBookingInviteDealAttributionOptions: 'getBookingInviteDealAttributionOptions',
    getBookingInvitePaymentSummary: 'getBookingInvitePaymentSummary',
    searchBookingInvitesByOutfitter: 'searchBookingInvitesByOutfitter',
    booking: 'booking',
    getDenialReasons: 'getDenialReasons',
    bookingCancellationInfo: 'bookingCancellationInfo',
    bookingUpdatesPreview: 'bookingUpdatesPreview',
    outfitterBookings: 'outfitterBookings',
    bulkOperation: 'bulkOperation',
    bulkOperations: 'bulkOperations',
    CalendarEvent: 'CalendarEvent',
    CalendarEvents: 'CalendarEvents',
    CalendarEventsByResourceType: 'CalendarEventsByResourceType',
    OutfitterBookingCalendarGroupingOptions: 'OutfitterBookingCalendarGroupingOptions',
    CalendarSubscription: 'CalendarSubscription',
    getCalendarSubscriptions: 'getCalendarSubscriptions',
    cancellationPolicies: 'cancellationPolicies',
    entityListCounts: 'entityListCounts',
    contactLists: 'contactLists',
    contactList: 'contactList',
    contactListContacts: 'contactListContacts',
    contactListPreviewContacts: 'contactListPreviewContacts',
    contacts: 'contacts',
    exportContactsCsv: 'exportContactsCsv',
    contact: 'contact',
    allCoupons: 'allCoupons',
    couponsByOutfitter: 'couponsByOutfitter',
    getCourierInboxAuthToken: 'getCourierInboxAuthToken',
    dashboardHome: 'dashboardHome',
    dashboardSearch: 'dashboardSearch',
    dashboardNavigationMenu: 'dashboardNavigationMenu',
    portalEntities: 'portalEntities',
    onboardingTasks: 'onboardingTasks',
    defaultAvailabilityRulesForResource: 'defaultAvailabilityRulesForResource',
    defaultAvailabilityRule: 'defaultAvailabilityRule',
    GetEventGroups: 'GetEventGroups',
    GetEventGroupForCalendar: 'GetEventGroupForCalendar',
    GetEventGroup: 'GetEventGroup',
    eventOrganizer: 'eventOrganizer',
    featureGate: 'featureGate',
    formSubmissions: 'formSubmissions',
    formSubmission: 'formSubmission',
    forms: 'forms',
    form: 'form',
    searchHubspotCompanies: 'searchHubspotCompanies',
    getInvoicePdf: 'getInvoicePdf',
    adminSearchLeads: 'adminSearchLeads',
    leadList: 'leadList',
    lead: 'lead',
    getAllLicenseInfos: 'getAllLicenseInfos',
    listing: 'listing',
    searchListings: 'searchListings',
    listingsByOutfitter: 'listingsByOutfitter',
    minimalListingsByOutfitter: 'minimalListingsByOutfitter',
    listingProgress: 'listingProgress',
    lodgingsByOwner: 'lodgingsByOwner',
    lodgingsByOutfitter: 'lodgingsByOutfitter',
    lodging: 'lodging',
    messageTemplate: 'messageTemplate',
    messageTemplates: 'messageTemplates',
    searchMessageTemplatesByOutfitter: 'searchMessageTemplatesByOutfitter',
    smsMessage: 'smsMessage',
    notificationTemplatePreview: 'notificationTemplatePreview',
    notificationTemplatePreviewMock: 'notificationTemplatePreviewMock',
    getOutfitterMetaConnectionsDetails: 'getOutfitterMetaConnectionsDetails',
    getMetaAdAccounts: 'getMetaAdAccounts',
    getMetaAdCampaigns: 'getMetaAdCampaigns',
    getMetaAdSets: 'getMetaAdSets',
    getMetaAds: 'getMetaAds',
    getMetaAggregatedAdMetrics: 'getMetaAggregatedAdMetrics',
    getMetaAdMetrics: 'getMetaAdMetrics',
    getMetric: 'getMetric',
    getTimeseriesMetric: 'getTimeseriesMetric',
    getMetricsByOutfitterAndKeys: 'getMetricsByOutfitterAndKeys',
    outfitterWebsiteTrackingMetrics: 'outfitterWebsiteTrackingMetrics',
    outfitterWebsiteTrackingAggregatedData: 'outfitterWebsiteTrackingAggregatedData',
    notes: 'notes',
    noteThreads: 'noteThreads',
    notificationSendLogs: 'notificationSendLogs',
    notificationSendLogMessage: 'notificationSendLogMessage',
    onboardings: 'onboardings',
    onboarding: 'onboarding',
    onboardingSubscriptionOptions: 'onboardingSubscriptionOptions',
    onboardingPaymentSummary: 'onboardingPaymentSummary',
    outfitterAssistantSuggestions: 'outfitterAssistantSuggestions',
    outfitterAutomationRuns: 'outfitterAutomationRuns',
    getOutfitterAutomationSetting: 'getOutfitterAutomationSetting',
    getOutfitterAutomationSettingsByGroup: 'getOutfitterAutomationSettingsByGroup',
    getOutfitterCustomProperties: 'getOutfitterCustomProperties',
    getEntityCustomProperties: 'getEntityCustomProperties',
    outfitterDocumentsByOutfitter: 'outfitterDocumentsByOutfitter',
    outfitterImages: 'outfitterImages',
    getOutfitterIntegrationSettings: 'getOutfitterIntegrationSettings',
    outfitter: 'outfitter',
    minimalOutfitter: 'minimalOutfitter',
    searchOutfitters: 'searchOutfitters',
    checkOutfitterSlug: 'checkOutfitterSlug',
    paymentRequest: 'paymentRequest',
    additionalPaymentSummary: 'additionalPaymentSummary',
    getPaymentSettings: 'getPaymentSettings',
    payment: 'payment',
    paymentsByOutfitter: 'paymentsByOutfitter',
    additionalBookingPaymentSummary: 'additionalBookingPaymentSummary',
    exportPaymentsCsvByOutfitter: 'exportPaymentsCsvByOutfitter',
    payouts: 'payouts',
    payoutTransactions: 'payoutTransactions',
    outfitterTeamMemberPeriodDigest: 'outfitterTeamMemberPeriodDigest',
    pricingPackage: 'pricingPackage',
    PricingPackagesByListing: 'PricingPackagesByListing',
    PricingPackagesWithAddOn: 'PricingPackagesWithAddOn',
    pricingPackagesByOutfitter: 'pricingPackagesByOutfitter',
    getQuickBooksCompanyInfo: 'getQuickBooksCompanyInfo',
    getQuickBooksDepositAccounts: 'getQuickBooksDepositAccounts',
    getQuickBooksClasses: 'getQuickBooksClasses',
    getQuickBooksItems: 'getQuickBooksItems',
    getQuickBooksClassMappings: 'getQuickBooksClassMappings',
    getQuickBooksItemOutfitterMappings: 'getQuickBooksItemOutfitterMappings',
    getQuickBooksItemListingMappings: 'getQuickBooksItemListingMappings',
    getQuoteRequestsForOutfitter: 'getQuoteRequestsForOutfitter',
    getQuoteRequest: 'getQuoteRequest',
    searchQuoteRequestsByOutfitter: 'searchQuoteRequestsByOutfitter',
    adminSearchQuoteRequests: 'adminSearchQuoteRequests',
    quote: 'quote',
    draftQuote: 'draftQuote',
    getRemainingPaymentsByBookingId: 'getRemainingPaymentsByBookingId',
    remainingPaymentsByOutfitter: 'remainingPaymentsByOutfitter',
    exportRemainingPaymentsCsvByOutfitter: 'exportRemainingPaymentsCsvByOutfitter',
    resourcesByOutfitter: 'resourcesByOutfitter',
    resource: 'resource',
    outfitterReviews: 'outfitterReviews',
    reviewsByGroupId: 'reviewsByGroupId',
    outfitterReviewAggregate: 'outfitterReviewAggregate',
    scheduledContactNotifications: 'scheduledContactNotifications',
    allSpecies: 'allSpecies',
    sportsmanPaymentBlocks: 'sportsmanPaymentBlocks',
    groupPayMemberPaymentBlocks: 'groupPayMemberPaymentBlocks',
    stripeAccountInfo: 'stripeAccountInfo',
    stripeBillingPortalUrl: 'stripeBillingPortalUrl',
    stripeConnectedAccountPortalUrl: 'stripeConnectedAccountPortalUrl',
    stripeSubscriptionPortalUrl: 'stripeSubscriptionPortalUrl',
    outfitterSubscriptionInfo: 'outfitterSubscriptionInfo',
    outfitterFeatureAccessInfo: 'outfitterFeatureAccessInfo',
    outfitterSubscriptionBillingPortalUrl: 'outfitterSubscriptionBillingPortalUrl',
    getSyncedCalendars: 'getSyncedCalendars',
    teamMember: 'teamMember',
    teamMembers: 'teamMembers',
    twilioConfiguration: 'twilioConfiguration',
    getUserNotificationPreferences: 'getUserNotificationPreferences',
    getUserTrackingData: 'getUserTrackingData',
    getUser: 'getUser',
    searchUsers: 'searchUsers',
    searchOutfittersForImpersonation: 'searchOutfittersForImpersonation',
    usersForMentions: 'usersForMentions',
    getOrCreateOutfitterWebsite: 'getOrCreateOutfitterWebsite',
    getWidget: 'getWidget',
    getWidgetsByOutfitter: 'getWidgetsByOutfitter'
  },
  Mutation: {
    createAddOn: 'createAddOn',
    updateAddOn: 'updateAddOn',
    removeAddOn: 'removeAddOn',
    updateAddOnOrders: 'updateAddOnOrders',
    createAiOnboarding: 'createAiOnboarding',
    createAmenity: 'createAmenity',
    updateAmenity: 'updateAmenity',
    acceptAuctionBids: 'acceptAuctionBids',
    bidOnAuction: 'bidOnAuction',
    createAuction: 'createAuction',
    updateAuction: 'updateAuction',
    StartImpersonation: 'StartImpersonation',
    StopImpersonation: 'StopImpersonation',
    updateAvailability: 'updateAvailability',
    acceptAvailabilityAiSuggestion: 'acceptAvailabilityAiSuggestion',
    sendAwardedItem: 'sendAwardedItem',
    createBadge: 'createBadge',
    updateBadge: 'updateBadge',
    updateOutfitterBadges: 'updateOutfitterBadges',
    archiveBanner: 'archiveBanner',
    createBookingInvite: 'createBookingInvite',
    updateBookingInvite: 'updateBookingInvite',
    duplicateBookingInvite: 'duplicateBookingInvite',
    archiveBookingInvite: 'archiveBookingInvite',
    updateBooking: 'updateBooking',
    acceptBooking: 'acceptBooking',
    cancelBooking: 'cancelBooking',
    updateBookingDatesGuestsAndAddons: 'updateBookingDatesGuestsAndAddons',
    updateFixedPriceBooking: 'updateFixedPriceBooking',
    declineBooking: 'declineBooking',
    createBookingAsOutfitter: 'createBookingAsOutfitter',
    createBooking: 'createBooking',
    createBookingForAwardedItem: 'createBookingForAwardedItem',
    removeOffsiteBooking: 'removeOffsiteBooking',
    createBookingBulkImport: 'createBookingBulkImport',
    assignGuidesToBooking: 'assignGuidesToBooking',
    assignResourcesToBooking: 'assignResourcesToBooking',
    assignLodgingsToBooking: 'assignLodgingsToBooking',
    UpdateCalendarEvent: 'UpdateCalendarEvent',
    ArchiveCalendarEvent: 'ArchiveCalendarEvent',
    CreateCalendarSubscription: 'CreateCalendarSubscription',
    UpdateCalendarSubscription: 'UpdateCalendarSubscription',
    ArchiveCalendarSubscription: 'ArchiveCalendarSubscription',
    createContactList: 'createContactList',
    updateContactList: 'updateContactList',
    archiveContactLists: 'archiveContactLists',
    addContactsToContactList: 'addContactsToContactList',
    removeContactsFromContactList: 'removeContactsFromContactList',
    createContacts: 'createContacts',
    createContact: 'createContact',
    updateContact: 'updateContact',
    archiveContacts: 'archiveContacts',
    createCoupon: 'createCoupon',
    removeCoupon: 'removeCoupon',
    createDefaultAvailabilityRule: 'createDefaultAvailabilityRule',
    updateDefaultAvailabilityRule: 'updateDefaultAvailabilityRule',
    archiveDefaultAvailabilityRule: 'archiveDefaultAvailabilityRule',
    optOutClientFromMarketing: 'optOutClientFromMarketing',
    CreateEventGroup: 'CreateEventGroup',
    DeleteEventGroup: 'DeleteEventGroup',
    UpdateEventGroup: 'UpdateEventGroup',
    updateEventOrganizer: 'updateEventOrganizer',
    createGenericEvent: 'createGenericEvent',
    createForm: 'createForm',
    updateForm: 'updateForm',
    deleteForm: 'deleteForm',
    duplicateForm: 'duplicateForm',
    updateGroupPayMember: 'updateGroupPayMember',
    createOutfitterFromHubspotCompany: 'createOutfitterFromHubspotCompany',
    sendInvoice: 'sendInvoice',
    createKnowledgeArticle: 'createKnowledgeArticle',
    updateKnowledgeArticle: 'updateKnowledgeArticle',
    publishKnowledgeArticle: 'publishKnowledgeArticle',
    createLead: 'createLead',
    createLeads: 'createLeads',
    updateLead: 'updateLead',
    updateLeads: 'updateLeads',
    archiveLeads: 'archiveLeads',
    updateLicenseInfo: 'updateLicenseInfo',
    createListing: 'createListing',
    updateListing: 'updateListing',
    updateListingLodgings: 'updateListingLodgings',
    duplicateListing: 'duplicateListing',
    deleteListing: 'deleteListing',
    UpdateListingsOrder: 'UpdateListingsOrder',
    updateListingRates: 'updateListingRates',
    updateListingRatesAsOwner: 'updateListingRatesAsOwner',
    createLodging: 'createLodging',
    updateLodging: 'updateLodging',
    deleteLodging: 'deleteLodging',
    createMessageTemplate: 'createMessageTemplate',
    updateMessageTemplate: 'updateMessageTemplate',
    archiveMessageTemplate: 'archiveMessageTemplate',
    duplicateMessageTemplate: 'duplicateMessageTemplate',
    sendMessages: 'sendMessages',
    restoreTemplateToDefault: 'restoreTemplateToDefault',
    sendNotificationTemplatePreviewMock: 'sendNotificationTemplatePreviewMock',
    initiateMetaConnection: 'initiateMetaConnection',
    disconnectMeta: 'disconnectMeta',
    createMetaAdAndCampaign: 'createMetaAdAndCampaign',
    updateMetaAd: 'updateMetaAd',
    createNote: 'createNote',
    updateNote: 'updateNote',
    markNoteThreadAsResolved: 'markNoteThreadAsResolved',
    markNoteThreadAsUnresolved: 'markNoteThreadAsUnresolved',
    archiveNoteThread: 'archiveNoteThread',
    deleteNote: 'deleteNote',
    markNoteThreadAsRead: 'markNoteThreadAsRead',
    markNoteAsUnread: 'markNoteAsUnread',
    sendBookingNotification: 'sendBookingNotification',
    createOnboarding: 'createOnboarding',
    updateOnboarding: 'updateOnboarding',
    archiveOnboarding: 'archiveOnboarding',
    updateOutfitterAutomationSetting: 'updateOutfitterAutomationSetting',
    createOutfitterCustomProperty: 'createOutfitterCustomProperty',
    archiveOutfitterCustomProperties: 'archiveOutfitterCustomProperties',
    setEntityCustomProperties: 'setEntityCustomProperties',
    createOutfitterDocument: 'createOutfitterDocument',
    updateOutfitterDocument: 'updateOutfitterDocument',
    archiveOutfitterDocument: 'archiveOutfitterDocument',
    createOutfitterImages: 'createOutfitterImages',
    upsertOutfitterIntegrationSettings: 'upsertOutfitterIntegrationSettings',
    initiateCustomEmailDomainAuth: 'initiateCustomEmailDomainAuth',
    verifyCustomEmailDomain: 'verifyCustomEmailDomain',
    removeCustomEmailDomain: 'removeCustomEmailDomain',
    updateOutfitter: 'updateOutfitter',
    updateOutfitterFees: 'updateOutfitterFees',
    approvedOutfitter: 'approvedOutfitter',
    suspendOutfitter: 'suspendOutfitter',
    removeOutfitter: 'removeOutfitter',
    reassignOutfitterOwner: 'reassignOutfitterOwner',
    updateSelfOnboardingStep: 'updateSelfOnboardingStep',
    updateOutfitterFeesAsOutfitterOwner: 'updateOutfitterFeesAsOutfitterOwner',
    upsertPaymentFeeSettings: 'upsertPaymentFeeSettings',
    deletePaymentFeeSettings: 'deletePaymentFeeSettings',
    createPaymentRequest: 'createPaymentRequest',
    confirmOfflinePaymentRequest: 'confirmOfflinePaymentRequest',
    cancelPaymentRequest: 'cancelPaymentRequest',
    upsertPaymentSettings: 'upsertPaymentSettings',
    updatePaymentDueDate: 'updatePaymentDueDate',
    createAdditionalBookingPayment: 'createAdditionalBookingPayment',
    createQuickPayPayment: 'createQuickPayPayment',
    updateQuickPayPayment: 'updateQuickPayPayment',
    cancelPayment: 'cancelPayment',
    markPaymentAsPaidOffline: 'markPaymentAsPaidOffline',
    markPaymentAsRefunded: 'markPaymentAsRefunded',
    markPaymentAsNotNeedingRefund: 'markPaymentAsNotNeedingRefund',
    updatePayment: 'updatePayment',
    retryPayment: 'retryPayment',
    updatePaymentMethodOnPayment: 'updatePaymentMethodOnPayment',
    initiateTransferToOutfiterForPayment: 'initiateTransferToOutfiterForPayment',
    deleteOfflinePayment: 'deleteOfflinePayment',
    CreatePricingPackage: 'CreatePricingPackage',
    UpdatePricingPackage: 'UpdatePricingPackage',
    RemovePricingPackage: 'RemovePricingPackage',
    UpdatePricingPackagesOrder: 'UpdatePricingPackagesOrder',
    initiateQuickBooksConnection: 'initiateQuickBooksConnection',
    disconnectQuickBooks: 'disconnectQuickBooks',
    updateQuickBooksClassMapping: 'updateQuickBooksClassMapping',
    updateQuickBooksItemMapping: 'updateQuickBooksItemMapping',
    archiveQuoteRequest: 'archiveQuoteRequest',
    createQuote: 'createQuote',
    applyQuoteCoupon: 'applyQuoteCoupon',
    removeQuoteCoupon: 'removeQuoteCoupon',
    enableQuotePaymentGroup: 'enableQuotePaymentGroup',
    disableQuotePaymentGroup: 'disableQuotePaymentGroup',
    addPackageToQuote: 'addPackageToQuote',
    updatePackageOnQuote: 'updatePackageOnQuote',
    removePackageFromQuote: 'removePackageFromQuote',
    updateQuotePaymentDueDate: 'updateQuotePaymentDueDate',
    createRefund: 'createRefund',
    setRemainingPaymentIsArchived: 'setRemainingPaymentIsArchived',
    createResource: 'createResource',
    deleteResource: 'deleteResource',
    updateResource: 'updateResource',
    sendContactListMarketingSms: 'sendContactListMarketingSms',
    sendContactListMarketingEmail: 'sendContactListMarketingEmail',
    sendContactMarketingSms: 'sendContactMarketingSms',
    sendContactMarketingEmail: 'sendContactMarketingEmail',
    createSpecies: 'createSpecies',
    updateSpecies: 'updateSpecies',
    deleteSpecies: 'deleteSpecies',
    createSetupIntent: 'createSetupIntent',
    createGroupPayMemberSetupIntent: 'createGroupPayMemberSetupIntent',
    deletePaymentMethod: 'deletePaymentMethod',
    processQuickPayPayment: 'processQuickPayPayment',
    createSetupIntentOnBehalfOf: 'createSetupIntentOnBehalfOf',
    updateOutfitterSubscription: 'updateOutfitterSubscription',
    updateOutfitterFeatureAccessSettings: 'updateOutfitterFeatureAccessSettings',
    createSyncedCalendar: 'createSyncedCalendar',
    updateSyncedCalendar: 'updateSyncedCalendar',
    archiveSyncedCalendar: 'archiveSyncedCalendar',
    acceptTeamMemberInvitation: 'acceptTeamMemberInvitation',
    createTeamMember: 'createTeamMember',
    updateTeamMember: 'updateTeamMember',
    deleteTeamMember: 'deleteTeamMember',
    sendTeamMemberInvite: 'sendTeamMemberInvite',
    retryBookingTripInsurancePurchase: 'retryBookingTripInsurancePurchase',
    registerForSms: 'registerForSms',
    markEntityAsRead: 'markEntityAsRead',
    updateUserNotificationPreferences: 'updateUserNotificationPreferences',
    user: 'user',
    createGuestUser: 'createGuestUser',
    updateWebsite: 'updateWebsite',
    publishWebsite: 'publishWebsite',
    createWidget: 'createWidget',
    updateWidget: 'updateWidget',
    removeWidget: 'removeWidget'
  },
  Fragment: {
    AddOnFormFields: 'AddOnFormFields',
    BookingAddOnFields: 'BookingAddOnFields',
    MinimalBookingAddOnFields: 'MinimalBookingAddOnFields',
    AddressFields: 'AddressFields',
    CityAndStateFields: 'CityAndStateFields',
    AiOnboardingFields: 'AiOnboardingFields',
    AiOnboardingSummaryItemFields: 'AiOnboardingSummaryItemFields',
    RichTextAiSuggestionFields: 'RichTextAiSuggestionFields',
    AmenityFields: 'AmenityFields',
    AppPromptCtaFields: 'AppPromptCtaFields',
    AppPromptImagesFields: 'AppPromptImagesFields',
    AppPromptFields: 'AppPromptFields',
    AuctionRequestFields: 'AuctionRequestFields',
    AuctionRequestWithEventOrganizerFields: 'AuctionRequestWithEventOrganizerFields',
    AuctionRequestEventOrganizerFields: 'AuctionRequestEventOrganizerFields',
    AuctionRequestAuctionFields: 'AuctionRequestAuctionFields',
    AuctionRequestRecipientFields: 'AuctionRequestRecipientFields',
    AuctionRequestBidFields: 'AuctionRequestBidFields',
    AuctionFields: 'AuctionFields',
    AvailabilityTimeWindowFields: 'AvailabilityTimeWindowFields',
    AvailabilityFields: 'AvailabilityFields',
    GenericAvailabilityNoteFields: 'GenericAvailabilityNoteFields',
    ResourceWithAvailabilitySupportFields: 'ResourceWithAvailabilitySupportFields',
    CheckoutCalendarAvailabilityTimeWindow: 'CheckoutCalendarAvailabilityTimeWindow',
    AwardedItemFields: 'AwardedItemFields',
    AwardedItemWithOrganizerFields: 'AwardedItemWithOrganizerFields',
    AwardedItemAuctionFields: 'AwardedItemAuctionFields',
    AwardedItemAuctionRequestFields: 'AwardedItemAuctionRequestFields',
    AwardedItemWinnerFields: 'AwardedItemWinnerFields',
    BannerFields: 'BannerFields',
    BannerContentFields: 'BannerContentFields',
    CallToActionFields: 'CallToActionFields',
    BookingInviteFields: 'BookingInviteFields',
    BookingInviteDetailsFields: 'BookingInviteDetailsFields',
    BookingInviteEditableFields: 'BookingInviteEditableFields',
    BookingInvitePackageFields: 'BookingInvitePackageFields',
    BookingFields: 'BookingFields',
    OutfitterBookingClientFields: 'OutfitterBookingClientFields',
    BookingFieldsWithStripeUrlsAndRefunds: 'BookingFieldsWithStripeUrlsAndRefunds',
    BookingFieldsWithQuote: 'BookingFieldsWithQuote',
    BookingPreviewFields: 'BookingPreviewFields',
    BookingForListFields: 'BookingForListFields',
    BookingCouponFields: 'BookingCouponFields',
    BookingPreviewWithRefundsFields: 'BookingPreviewWithRefundsFields',
    ValueChangeFields: 'ValueChangeFields',
    DenialReasonFields: 'DenialReasonFields',
    BookingPackageFields: 'BookingPackageFields',
    BookingItemFields: 'BookingItemFields',
    BookingCancellationInfoFields: 'BookingCancellationInfoFields',
    BookingCancellationMemberInfoFields: 'BookingCancellationMemberInfoFields',
    BookingPaymentSummaryFields: 'BookingPaymentSummaryFields',
    MemberPaymentSummaryFields: 'MemberPaymentSummaryFields',
    EventGroupBookingListFields: 'EventGroupBookingListFields',
    BulkOperationErrorFields: 'BulkOperationErrorFields',
    BulkOperationFields: 'BulkOperationFields',
    CalendarEventFields: 'CalendarEventFields',
    MinimalCalendarEventFields: 'MinimalCalendarEventFields',
    CalendarEventDateFields: 'CalendarEventDateFields',
    CalendarEventCalculatedColorsFields: 'CalendarEventCalculatedColorsFields',
    CalendarEventColorsFields: 'CalendarEventColorsFields',
    CalendarEventDetailsItemFields: 'CalendarEventDetailsItemFields',
    CalendarSubscriptionFields: 'CalendarSubscriptionFields',
    MinimalResourceFields: 'MinimalResourceFields',
    CancellationPolicyFields: 'CancellationPolicyFields',
    AttributionFields: 'AttributionFields',
    BadgeFields: 'BadgeFields',
    PaymentCustomerFields: 'PaymentCustomerFields',
    TripItineraryItemFields: 'TripItineraryItemFields',
    TripItineraryFields: 'TripItineraryFields',
    EntityListCountFields: 'EntityListCountFields',
    EntityListCountsFields: 'EntityListCountsFields',
    FormFields: 'FormFields',
    FormInputFields: 'FormInputFields',
    TripInsuranceFields: 'TripInsuranceFields',
    BookingPaymentFields: 'BookingPaymentFields',
    BookingPaymentWithRefundsFields: 'BookingPaymentWithRefundsFields',
    PaymentRetryFields: 'PaymentRetryFields',
    BookingPaymentWithStripeUrlAndRefundsFields: 'BookingPaymentWithStripeUrlAndRefundsFields',
    ContactListFilterFields: 'ContactListFilterFields',
    ContactListFields: 'ContactListFields',
    MinimalContactFields: 'MinimalContactFields',
    ContactFields: 'ContactFields',
    CouponFields: 'CouponFields',
    DashboardHomeFeature: 'DashboardHomeFeature',
    DashboardHomeTip: 'DashboardHomeTip',
    DashboardHomeAlert: 'DashboardHomeAlert',
    DashboardHomeQuickAction: 'DashboardHomeQuickAction',
    DashboardHomeBannerSectionFields: 'DashboardHomeBannerSectionFields',
    DashboardHomeHighPriorityOutfitterBannerSectionFields: 'DashboardHomeHighPriorityOutfitterBannerSectionFields',
    DashboardHomeBookingsSectionFields: 'DashboardHomeBookingsSectionFields',
    DashboardHomeQuickAccessSectionFields: 'DashboardHomeQuickAccessSectionFields',
    DashboardHomeTipsSectionFields: 'DashboardHomeTipsSectionFields',
    DashboardHomeReportingSectionFields: 'DashboardHomeReportingSectionFields',
    DashboardHomeFeaturesSectionFields: 'DashboardHomeFeaturesSectionFields',
    DashboardHomeAlertsSectionFields: 'DashboardHomeAlertsSectionFields',
    DashboardHomeSectionFields: 'DashboardHomeSectionFields',
    DashboardSearchGroupFields: 'DashboardSearchGroupFields',
    NavigationMenuGroupFields: 'NavigationMenuGroupFields',
    NavigationMenuItemFields: 'NavigationMenuItemFields',
    PortalEntitiesFields: 'PortalEntitiesFields',
    OnboardingTaskActionFields: 'OnboardingTaskActionFields',
    OnboardingTaskFields: 'OnboardingTaskFields',
    OnboardingTaskSectionFields: 'OnboardingTaskSectionFields',
    DefaultAvailabilityRuleTimeWindowFields: 'DefaultAvailabilityRuleTimeWindowFields',
    DefaultAvailabilityRuleDayScheduleFields: 'DefaultAvailabilityRuleDayScheduleFields',
    DefaultAvailabilityRuleFields: 'DefaultAvailabilityRuleFields',
    EventGroupFields: 'EventGroupFields',
    CalendarViewGroupDisplayFields: 'CalendarViewGroupDisplayFields',
    EventGroupCalendarEventFields: 'EventGroupCalendarEventFields',
    EventGroupListFields: 'EventGroupListFields',
    EventOrganizerFields: 'EventOrganizerFields',
    EventOrganizerTeamMemberFields: 'EventOrganizerTeamMemberFields',
    FeatureGateCtaFields: 'FeatureGateCtaFields',
    FeatureGateImageFields: 'FeatureGateImageFields',
    FeatureGateFields: 'FeatureGateFields',
    FormSubmissionFields: 'FormSubmissionFields',
    FormWithSubmissionFields: 'FormWithSubmissionFields',
    GroupPayMemberFields: 'GroupPayMemberFields',
    GroupPayShareFields: 'GroupPayShareFields',
    GroupPayShareWithFullPaymentDetailsFields: 'GroupPayShareWithFullPaymentDetailsFields',
    SlotShareFields: 'SlotShareFields',
    SlotShareWithFullPaymentDetailsFields: 'SlotShareWithFullPaymentDetailsFields',
    LeadFields: 'LeadFields',
    SourceEntityFields: 'SourceEntityFields',
    SourceFormDataFields: 'SourceFormDataFields',
    UpdateLeadsResultFields: 'UpdateLeadsResultFields',
    LicenseInfoFields: 'LicenseInfoFields',
    ListingOutfitterFields: 'ListingOutfitterFields',
    ListingFields: 'ListingFields',
    MinimalListingFields: 'MinimalListingFields',
    ListingNotesFields: 'ListingNotesFields',
    ListingProgressFields: 'ListingProgressFields',
    LodgingFields: 'LodgingFields',
    MediaFields: 'MediaFields',
    MinimalMessageTemplateFields: 'MinimalMessageTemplateFields',
    MessageTemplateFields: 'MessageTemplateFields',
    MessageTemplateEmailContentFields: 'MessageTemplateEmailContentFields',
    MessageTemplateSmsContentFields: 'MessageTemplateSmsContentFields',
    MessageTemplatesResultsFields: 'MessageTemplatesResultsFields',
    MessageTemplateSearchResultsFields: 'MessageTemplateSearchResultsFields',
    TemplateVariableFields: 'TemplateVariableFields',
    MetaConnectionFields: 'MetaConnectionFields',
    MetaConnectionsResultFields: 'MetaConnectionsResultFields',
    MetaAdAccountFields: 'MetaAdAccountFields',
    MetaAdAccountsResultsFields: 'MetaAdAccountsResultsFields',
    MetaAdCampaignsResultsFields: 'MetaAdCampaignsResultsFields',
    MetaAdCampaignFields: 'MetaAdCampaignFields',
    MetaAdSetsResultsFields: 'MetaAdSetsResultsFields',
    MetaAdSetFields: 'MetaAdSetFields',
    MetaAdsResultsFields: 'MetaAdsResultsFields',
    MetaAdFields: 'MetaAdFields',
    MetaAggregatedAdMetricsResultFields: 'MetaAggregatedAdMetricsResultFields',
    MetaAdMetricsResultFields: 'MetaAdMetricsResultFields',
    MetaAdMetricsFields: 'MetaAdMetricsFields',
    UpdateMetaAdResultFields: 'UpdateMetaAdResultFields',
    MetricFields: 'MetricFields',
    NoteFields: 'NoteFields',
    NoteThreadFields: 'NoteThreadFields',
    MinimalNotificationSendLogFields: 'MinimalNotificationSendLogFields',
    NotificationSendLogMessageFields: 'NotificationSendLogMessageFields',
    NotificationSendLogsResultsFields: 'NotificationSendLogsResultsFields',
    MinimalOnboardingFields: 'MinimalOnboardingFields',
    OnboardingFields: 'OnboardingFields',
    IdAndNameFields: 'IdAndNameFields',
    OnboardingSubscriptionOptionsFields: 'OnboardingSubscriptionOptionsFields',
    AutomationRunErrorFields: 'AutomationRunErrorFields',
    OutfitterAutomationRunFields: 'OutfitterAutomationRunFields',
    PaginatedOutfitterAutomationRunsFields: 'PaginatedOutfitterAutomationRunsFields',
    AutomationTemplateFields: 'AutomationTemplateFields',
    AutomationStepFields: 'AutomationStepFields',
    AutomationTriggerFields: 'AutomationTriggerFields',
    OffsetDaysConfigFields: 'OffsetDaysConfigFields',
    OutfitterAutomationSettingFields: 'OutfitterAutomationSettingFields',
    OutfitterAutomationSettingsListItemFields: 'OutfitterAutomationSettingsListItemFields',
    OutfitterAutomationSettingsByGroupFields: 'OutfitterAutomationSettingsByGroupFields',
    OutfitterCustomPropertyFields: 'OutfitterCustomPropertyFields',
    EntityPropertyValueFields: 'EntityPropertyValueFields',
    EntityCustomPropertyFields: 'EntityCustomPropertyFields',
    GetEntityCustomPropertiesResultFields: 'GetEntityCustomPropertiesResultFields',
    SetEntityCustomPropertiesResultFields: 'SetEntityCustomPropertiesResultFields',
    OutfitterDocumentFields: 'OutfitterDocumentFields',
    OutfitterImageFields: 'OutfitterImageFields',
    OutfitterImageGroupFields: 'OutfitterImageGroupFields',
    QuickBooksIntegrationSettingsFields: 'QuickBooksIntegrationSettingsFields',
    OutfitterIntegrationSettingsFields: 'OutfitterIntegrationSettingsFields',
    CustomEmailDomainDnsRecordFields: 'CustomEmailDomainDnsRecordFields',
    CustomEmailDomainConfigFields: 'CustomEmailDomainConfigFields',
    OutfitterListingFields: 'OutfitterListingFields',
    OutfitterOtherInfoFields: 'OutfitterOtherInfoFields',
    OutfitterTeamMemberFields: 'OutfitterTeamMemberFields',
    FeatureAccessFields: 'FeatureAccessFields',
    OutfitterFields: 'OutfitterFields',
    MinimalOutfitterFields: 'MinimalOutfitterFields',
    EnabledOutfitterIntegrationsFields: 'EnabledOutfitterIntegrationsFields',
    OutfitterCancellationPolicyFields: 'OutfitterCancellationPolicyFields',
    CheckInConfigFields: 'CheckInConfigFields',
    FaqItemFields: 'FaqItemFields',
    OutfitterTaxDefinitionFields: 'OutfitterTaxDefinitionFields',
    OutfitterTaxDefinitionsList: 'OutfitterTaxDefinitionsList',
    PaymentFeeSettingsFields: 'PaymentFeeSettingsFields',
    PaymentRequestFields: 'PaymentRequestFields',
    PaymentRequestSummaryFields: 'PaymentRequestSummaryFields',
    PaymentSettingsFields: 'PaymentSettingsFields',
    PaymentFields: 'PaymentFields',
    PaymentListFields: 'PaymentListFields',
    PayoutFields: 'PayoutFields',
    PayoutTransactionFields: 'PayoutTransactionFields',
    PayoutTransactionPaymentFields: 'PayoutTransactionPaymentFields',
    PayoutTimelineFields: 'PayoutTimelineFields',
    PricingPackageAddOnFields: 'PricingPackageAddOnFields',
    SelectablePricingPackageFields: 'SelectablePricingPackageFields',
    PricingPackageWithBookableTimeWindowsFields: 'PricingPackageWithBookableTimeWindowsFields',
    PricingPackageFields: 'PricingPackageFields',
    QuickBooksDepositAccountFields: 'QuickBooksDepositAccountFields',
    QuickBooksDepositAccountsResultFields: 'QuickBooksDepositAccountsResultFields',
    QuickBooksCompanyInfoFields: 'QuickBooksCompanyInfoFields',
    QuickBooksClassMappingsResultFields: 'QuickBooksClassMappingsResultFields',
    QuickBooksItemOutfitterMappingsResultFields: 'QuickBooksItemOutfitterMappingsResultFields',
    QuickBooksItemListingMappingsResultFields: 'QuickBooksItemListingMappingsResultFields',
    QuickBooksItemMappingFields: 'QuickBooksItemMappingFields',
    QuickBooksListingClassMappingFields: 'QuickBooksListingClassMappingFields',
    QuickBooksClassesResultFields: 'QuickBooksClassesResultFields',
    QuickBooksItemsResultFields: 'QuickBooksItemsResultFields',
    QuickBooksClassFields: 'QuickBooksClassFields',
    QuickBooksItemFields: 'QuickBooksItemFields',
    QuoteRequestFields: 'QuoteRequestFields',
    AddOnQuoteFields: 'AddOnQuoteFields',
    PaymentSummaryFields: 'PaymentSummaryFields',
    LineItemFields: 'LineItemFields',
    SubItemFields: 'SubItemFields',
    QuoteItemFields: 'QuoteItemFields',
    QuoteListingFields: 'QuoteListingFields',
    QuotePaymentPlanFields: 'QuotePaymentPlanFields',
    QuotePaymentGroupMemberFields: 'QuotePaymentGroupMemberFields',
    QuotePaymentGroupFields: 'QuotePaymentGroupFields',
    QuotePackageFields: 'QuotePackageFields',
    QuoteInterfaceFields: 'QuoteInterfaceFields',
    QuoteFields: 'QuoteFields',
    QuotePriceFields: 'QuotePriceFields',
    QuoteCouponFields: 'QuoteCouponFields',
    RefundFields: 'RefundFields',
    RemainingPaymentFields: 'RemainingPaymentFields',
    ResourceFields: 'ResourceFields',
    ReviewFields: 'ReviewFields',
    ReviewAggregationFields: 'ReviewAggregationFields',
    MinimalScheduledContactNotificationFields: 'MinimalScheduledContactNotificationFields',
    SpeciesFields: 'SpeciesFields',
    PaymentBlockFields: 'PaymentBlockFields',
    StripeSetupIntentFields: 'StripeSetupIntentFields',
    StripePaymentIntentFields: 'StripePaymentIntentFields',
    OutfitterSubscriptionInfoFields: 'OutfitterSubscriptionInfoFields',
    OutfitterFeatureAccessInfoFields: 'OutfitterFeatureAccessInfoFields',
    FeatureAccessSettingFields: 'FeatureAccessSettingFields',
    SyncedCalendarFields: 'SyncedCalendarFields',
    TeamMemberFields: 'TeamMemberFields',
    MinimalTeamMemberFields: 'MinimalTeamMemberFields',
    OutfitterTwilioConfigurationFields: 'OutfitterTwilioConfigurationFields',
    UnreadEntitiesMutationResult: 'UnreadEntitiesMutationResult',
    UserNotificationSettingFields: 'UserNotificationSettingFields',
    UserNotificationPreferenceCatalogTopicFields: 'UserNotificationPreferenceCatalogTopicFields',
    UserNotificationPreferencesFields: 'UserNotificationPreferencesFields',
    UserFields: 'UserFields',
    PublicUserFields: 'PublicUserFields',
    CurrentUserFields: 'CurrentUserFields',
    WebsiteFields: 'WebsiteFields',
    WebsitePageFields: 'WebsitePageFields',
    WebsiteFontFields: 'WebsiteFontFields',
    WebsiteScriptFields: 'WebsiteScriptFields',
    WidgetFields: 'WidgetFields'
  }
}